import React from 'react';
import { Box } from '../../Box';
import { useSteppedProcess } from '../context';
const StepContent = ({ stepIndex, step }) => {
    const { activeStep } = useSteppedProcess();
    return (activeStep === null || activeStep === void 0 ? void 0 : activeStep.index) === stepIndex ? (React.createElement(Box, { display: "flex", flexDirection: "column", width: "100%", "data-testid": `mui-step-${stepIndex}-content` }, step.content)) : (React.createElement(React.Fragment, null));
};
export { StepContent };
//# sourceMappingURL=StepContent.js.map